import { Element } from "@js/extends";

export default class ResultsTemplate extends Element {
	mounted() {
		this.modalToggle = this.el.querySelector(".js-results-template-toggle");
		this.modalClose = this.el.querySelector(".js-results-template-close");
		this.modalSubmit = this.el.querySelector(".js-results-template-submit");
		this.target = this.el.querySelector(".js-results-template-target");
		this.body = document.body;
		this.hiddenClass = "is-hidden";
		this.isOpen = false;

		this.handleClick = this.handleClick.bind(this);
	}

	events() {
		if (!this.modalToggle || !this.modalClose || !this.modalSubmit) return;

		[this.modalToggle, this.modalClose, this.modalSubmit].forEach((el) => {
			el.addEventListener("click", (e) => this.handleClick(e));
		});
	}

	handleClick(e) {
		e.preventDefault();

		if (e.pointerType === "mouse" || e.pointerType === "touch") {
			this.toggle();
		}
	}

	toggle() {
		this.isOpen ? this.close() : this.open();
	}

	open() {
		this.updateState(true);
		this.body.classList.add("is-locked");
		this.target.classList.remove(this.hiddenClass);
	}

	close() {
		this.updateState(false);
		this.body.classList.remove("is-locked");
		this.target.classList.add(this.hiddenClass);
	}

	updateState(isOpen) {
		this.isOpen = isOpen;
		this.modalToggle.ariaExpanded = isOpen;
	}
}
